import main from './lib/BamArgValidator';

export default main;

